<template>
  <div class="playlist-share">
    <Modal v-if="open" class="mk-modal" @close="close">
      <slot>
        <div class="tabs">
          <div class="tabs-header">
            <a :class="{active: tabIndex === 0}" class="tab share" @click="tabIndex = 0">
              {{ $t('COMMON.SHARE') }}
            </a>
            <a :class="{active: tabIndex === 1}" class="tab embed" @click="tabIndex = 1">
              {{ $t('COMMON.EMBED') }}
            </a>
          </div>
          <div class="tabs-body">
            <div v-if="playlist && tabIndex === 0" class="share">
              <SocialShare
                :title="title"
                :subtitle="subtitle"
                :cover="cover"
                :share-link="shareLink"
                :share-link-label="shareLinkLabel"
              />
            </div>
            <div v-if="tabIndex === 1" class="embed">
              <SocialShareLink
                :share-link-label="embedLinkLabel"
                :share-link="embedIframeLink"
              />
              <div class="embed-container">
                <iframe :src="embedLink" width="100%" frameborder="0" />
              </div>
            </div>
          </div>
        </div>
      </slot>
    </Modal>
  </div>
</template>

<script>
import { displayLocaleTitle } from '@/assets/helpers/PlaylistHelper'
import Modal from '@/components/common/Modal'
import SocialShare from '@/components/common/SocialShare'
import SocialShareLink from '@/components/common/SocialShareLink'
import ImgLoader from '@/directives/ImgLoader'

export default {
  name: 'PlaylistShareModal',
  components: {
    Modal,
    SocialShare,
    SocialShareLink
  },
  directives: {
    ImgLoader
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    playlist: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    cover: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tabIndex: 0
    }
  },
  computed: {
    shareLink() {
      // return window.location.href
      return `${window.location.protocol}//${window.location.host}/${this.$i18n.localePath()}/playlists/${this.playlist.id}`
    },
    embedLink() {
      // return window.location.href
      return `${window.location.protocol}//${window.location.host}/${this.$i18n.localePath()}/embed/playlists/${this.playlist.id}`
    },
    embedIframeLink() {
      // return window.location.href
      return `<iframe src="${this.embedLink}" width="100%" scrolling="no" frameborder="0"></iframe>`
    },
    shareLinkLabel() {
      return this.$t('COMMON.SHARE_LINK')
    },
    embedLinkLabel() {
      return this.$t('COMMON.EMBED')
    }

  },
  watch: {},
  created() {},
  mounted() {
  },
  updated() {},
  methods: {
    displayLocaleTitle,
    close() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/component/button.scss';
@import '@/assets/scss/variables.scss';

.playlist-share {
  position: relative;
  overflow: hidden;
  .tabs-header {
    .tab {
      display: inline-block;
      min-width: 129px;
      height: 62px;
      line-height: 62px;
      text-align: center;
      font-size: 16px;
      font-weight: 700;
      cursor: pointer;
      border-bottom: solid 3px transparent;
      transition: all .3s ease;
      color: $grey-9b;
      &.active {
        border-bottom: solid 3px $theme-red;
        color: $grey-50;
      }
    }
  }
  .tabs-body {
    .embed {
      margin-top: 24px;
      &-container {
        position: relative;
        margin: 24px 0;
        border: solid 1px $grey-ec;
        iframe {
          width: 100%;
          min-height: 400px;
        }
      }
    }
    .share {}
  }
}
@media only screen and (min-width: 1440px) {}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {}
@media only screen and (max-width: 767.98px) {
  .playlist-share {
    .tabs-body {
      .embed {}
      .share {}
    }
  }
}

</style>
